/*
  Pack lines in the cart (snippets/cart-line-items.liquid): the pack select replaces the
  quantity stepper, so the label always matches the real quantity. Changing it rewrites the
  line's quantity and pack properties; switching to one unit swaps in a plain line.
*/
(function () {
  if (window.__packCartBound) return;
  window.__packCartBound = true;

  var PACK_KEYS = ['_pack', '_pack_img', 'מארז'];

  function cartChangeUrl() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || '/cart/change';
    return /\.js$/.test(url) ? url : url + '.js';
  }

  function cartAddUrl() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    return /\.js$/.test(url) ? url : url + '.js';
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) throw new Error(url + ' failed: ' + response.status);
      return response.json();
    });
  }

  function nextProperties(select, option, qty) {
    var properties = {};
    try {
      var parsed = JSON.parse(select.dataset.properties || '{}') || {};
      // Liquid's `json` filter outputs line properties as [key, value] pairs.
      properties = Array.isArray(parsed) ? Object.fromEntries(parsed) : parsed;
    } catch (error) {
      properties = {};
    }
    PACK_KEYS.forEach(function (key) {
      delete properties[key];
    });

    if (qty > 1) {
      properties._pack = String(qty);
      if (option.dataset.imagePath) properties._pack_img = option.dataset.imagePath;
      properties['מארז'] = option.dataset.label || qty + ' יחידות';
    }
    return properties;
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-pack-line-select]');
    if (!select) return;

    var option = select.options[select.selectedIndex];
    var qty = parseInt(select.value, 10) || 1;
    var item = select.closest('[data-cart-item]');
    if (item) item.classList.add('is-loading');
    select.disabled = true;

    var properties = nextProperties(select, option, qty);
    var request;
    if (qty > 1) {
      request = postJson(cartChangeUrl(), { id: select.dataset.key, quantity: qty, properties: properties });
    } else {
      // Shopify keeps property keys on /cart/change (it only blanks them), so a single unit
      // replaces the pack line with a plain one.
      request = postJson(cartChangeUrl(), { id: select.dataset.key, quantity: 0 }).then(function () {
        var line = { id: Number(select.dataset.variantId), quantity: 1 };
        if (Object.keys(properties).length) line.properties = properties;
        return postJson(cartAddUrl(), { items: [line] });
      });
    }

    request
      .then(function () {
        if (select.closest('[data-cart-drawer]') || document.querySelector('cart-element[data-cart-drawer]')) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } else {
          window.location.reload();
        }
      })
      .catch(function (error) {
        console.error('[pack-cart]', error);
        window.location.reload();
      });
  });
})();
